










































































import { defineComponent, PropType, computed, ref } from '@vue/composition-api';
import { Thread, ThreadStatus } from '@oare/types';
import sl from '@/serviceLocator';
import { resetAdminBadge } from '@/utils';

export default defineComponent({
  props: {
    thread: {
      type: Object as PropType<Thread>,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const store = sl.get('store');

    const editThreadNameDialog = ref(false);
    const loading = ref(false);
    const newThreadName = ref(props.thread.name || '');
    const editErrorMessage = ref('');

    const statuses = ref<ThreadStatus[]>([
      'New',
      'Pending',
      'In Progress',
      'Completed',
    ]);

    const displayThreadName = computed(() => {
      return props.thread.name || 'Untitled';
    });

    const selectThread = () => {
      emit('selected', props.thread.uuid);
    };

    const validThreadName = computed(() => {
      let valid = true;
      if (newThreadName.value === '') {
        editErrorMessage.value = 'New thread name cannot be empty.';
        valid = false;
      }

      return valid;
    });

    const user = computed(() => store.getters.user);

    const isAdmin = computed(() => user.value && user.value.isAdmin);

    const updateThreadName = async () => {
      loading.value = true;
      try {
        await server.updateThreadName({
          threadUuid: props.thread.uuid,
          newName: newThreadName.value,
        });
        actions.showSnackbar(`Successfully edited the thread name.`);
        emit('nameUpdated', newThreadName.value);
        editThreadNameDialog.value = false;
      } catch (err) {
        actions.showErrorSnackbar('Failed to edit thread name', err as Error);
      } finally {
        loading.value = false;
        newThreadName.value = '';
      }
    };

    const updateThreadStatus = async (status: ThreadStatus) => {
      // Only update if status changes from the original value.
      if (status !== props.thread.status) {
        try {
          loading.value = true;
          props.thread.status = status;
          await server.updateThread(props.thread);

          actions.showSnackbar('Successfully updated the thread');
          emit('statusUpdated');
          await resetAdminBadge();
        } catch (err) {
          actions.showErrorSnackbar(
            'Failed to update the thread',
            err as Error
          );
        } finally {
          loading.value = false;
        }
      }
    };

    return {
      displayThreadName,
      selectThread,
      editThreadNameDialog,
      statuses,
      loading,
      newThreadName,
      updateThreadName,
      editErrorMessage,
      validThreadName,
      isAdmin,
      updateThreadStatus,
    };
  },
});
